(function () {
  "use strict";

  /* ============================================================
     GLOBAL REGISTRY — tracks intervals so we can mass-kill them
     before every Barba transition
     ============================================================ */
  window.__emanuelnine = window.__emanuelnine || {};
  var REG = window.__emanuelnine;
  REG.timers = REG.timers || [];

  function clearRegTimers() {
    REG.timers.forEach(function (id) {
      clearInterval(id);
    });
    REG.timers = [];
  }

  function regInterval(fn, ms) {
    var id = setInterval(fn, ms);
    REG.timers.push(id);
    return id;
  }

  /* ============================================================
     1. HEADER NAVIGATION (persistent — already idempotent)
     ============================================================ */
  function initHeaderNavigation() {
    var header = document.querySelector(".header");
    var toggleBtn = document.getElementById("toggleBtn");
    var toggleIcon = document.getElementById("toggleIcon");
    var navMenu = document.getElementById("navMenu");

    if (!header || !navMenu) return;

    var isMobileMenu = function () {
      return (
        typeof window !== "undefined" &&
        typeof window.matchMedia === "function" &&
        window.matchMedia("(max-width: 1024px)").matches
      );
    };

    var syncMenuState = function (isOpen) {
      navMenu.classList.toggle("open", isOpen);
      document.body.classList.toggle("menu-open", isOpen);
      if (toggleIcon) toggleIcon.textContent = "///";
    };

    if (toggleBtn && toggleBtn.dataset.boundNavToggle !== "1") {
      toggleBtn.addEventListener("click", function () {
        syncMenuState(!navMenu.classList.contains("open"));
      });
      toggleBtn.dataset.boundNavToggle = "1";
    }

    header.querySelectorAll(".nav-link").forEach(function (link) {
      if (link.dataset.boundNavLinkClose === "1") return;

      link.addEventListener("click", function () {
        var parentItem = link.parentElement;
        if (
          parentItem &&
          parentItem.classList.contains("menu-item-has-children")
        ) {
          return;
        }
        syncMenuState(false);
        header
          .querySelectorAll(".menu-item-has-children.open")
          .forEach(function (item) {
            item.classList.remove("open");
          });
      });
      link.dataset.boundNavLinkClose = "1";
    });

    header
      .querySelectorAll(".menu-item-has-children")
      .forEach(function (parent) {
        var link = parent.querySelector(":scope > .nav-link");
        if (!link) return;

        if (!link.hasAttribute("aria-expanded")) {
          link.setAttribute("aria-expanded", "false");
        }
        if (link.dataset.boundSubmenuToggle === "1") return;

        link.addEventListener("click", function (event) {
          event.preventDefault();
          event.stopPropagation();

          var willOpen = !parent.classList.contains("open");

          header
            .querySelectorAll(".menu-item-has-children.open")
            .forEach(function (item) {
              if (item !== parent) {
                item.classList.remove("open");
                var itemLink = item.querySelector(":scope > .nav-link");
                if (itemLink) itemLink.setAttribute("aria-expanded", "false");
              }
            });

          parent.classList.toggle("open", willOpen);
          link.setAttribute("aria-expanded", willOpen ? "true" : "false");

          if (isMobileMenu()) syncMenuState(true);
        });
        link.dataset.boundSubmenuToggle = "1";
      });

    if (document.body.dataset.boundHeaderOutsideClick !== "1") {
      document.addEventListener("click", function (event) {
        if (event.target.closest(".menu-item-has-children")) return;
        document
          .querySelectorAll(".menu-item-has-children.open")
          .forEach(function (item) {
            item.classList.remove("open");
            var itemLink = item.querySelector(":scope > .nav-link");
            if (itemLink) itemLink.setAttribute("aria-expanded", "false");
          });
      });
      document.body.dataset.boundHeaderOutsideClick = "1";
    }
  }

  /* ============================================================
     2. HERO CAROUSEL
     ============================================================ */
  function initHeroCarousel() {
    var carousel = document.querySelector(".hero-carousel");
    if (!carousel) return;

    if (carousel._heroTimer) clearInterval(carousel._heroTimer);

    var words = carousel.querySelectorAll(".hero-carousel-word");
    var descs = carousel.querySelectorAll(".hero-carousel-desc");
    var slides = carousel.querySelectorAll(".hero-carousel-slide");
    var btnPrev = carousel.querySelector(".hero-carousel-arrow--prev");
    var btnNext = carousel.querySelector(".hero-carousel-arrow--next");

    if (
      !slides.length ||
      words.length !== slides.length ||
      descs.length !== slides.length
    )
      return;

    var current = 0;
    var total = slides.length;
    var leavingEls = new Set();

    function resetSlidePosition(slide) {
      slide.style.transition = "none";
      slide.classList.remove("is-leaving");
      void slide.offsetWidth;
      slide.style.transition = "";
    }

    slides.forEach(function (slide, i) {
      resetSlidePosition(slide);
      slide.classList.toggle("is-active", i === 0);
    });
    words.forEach(function (w, i) {
      w.classList.toggle("is-active", i === 0);
    });
    descs.forEach(function (d, i) {
      d.classList.toggle("is-active", i === 0);
    });

    function goTo(index) {
      if (index < 0) index = total - 1;
      if (index >= total) index = 0;
      if (index === current) return;

      var prevIndex = current;
      words[prevIndex].classList.remove("is-active");
      descs[prevIndex].classList.remove("is-active");

      var leavingSlide = slides[prevIndex];
      leavingSlide.classList.remove("is-active");
      leavingSlide.classList.add("is-leaving");
      leavingEls.add(leavingSlide);

      var onTransitionEnd = function (e) {
        if (e.propertyName !== "transform") return;
        resetSlidePosition(leavingSlide);
        leavingEls.delete(leavingSlide);
        leavingSlide.removeEventListener("transitionend", onTransitionEnd);
      };
      leavingSlide.addEventListener("transitionend", onTransitionEnd);

      current = index;
      words[current].classList.add("is-active");
      descs[current].classList.add("is-active");
      slides[current].classList.add("is-active");
    }

    words.forEach(function (word) {
      word.addEventListener("click", function () {
        goTo(parseInt(this.dataset.index, 10));
        resetAuto();
      });
    });

    if (btnPrev) {
      btnPrev.addEventListener("click", function () {
        goTo(current - 1);
        resetAuto();
      });
    }
    if (btnNext) {
      btnNext.addEventListener("click", function () {
        goTo(current + 1);
        resetAuto();
      });
    }

    var autoTimer = null;
    function startAuto() {
      autoTimer = regInterval(function () {
        goTo(current + 1);
      }, 5000);
      carousel._heroTimer = autoTimer;
    }
    function resetAuto() {
      clearInterval(autoTimer);
      startAuto();
    }

    carousel._heroCtrl = {
      goTo: goTo,
      next: function () {
        goTo(current + 1);
      },
      prev: function () {
        goTo(current - 1);
      },
      resetAuto: resetAuto,
    };

    goTo(0);
    startAuto();
  }

  /* Global keydown for hero carousels — bound ONCE */
  if (!REG.heroKeydownBound) {
    document.addEventListener("keydown", function (e) {
      document.querySelectorAll(".hero-carousel").forEach(function (c) {
        if (!c._heroCtrl) return;
        if (e.key === "ArrowLeft") {
          c._heroCtrl.prev();
          c._heroCtrl.resetAuto();
        }
        if (e.key === "ArrowRight") {
          c._heroCtrl.next();
          c._heroCtrl.resetAuto();
        }
      });
    });
    REG.heroKeydownBound = true;
  }

  /* ============================================================
     3. VISIT SHOWCASE SLIDER
     ============================================================ */
  function initVisitSlider() {
    var slider = document.querySelector(".visit-slider");
    if (!slider) return;

    if (slider._visitTimer) clearInterval(slider._visitTimer);

    var track = slider.querySelector(".visit-slider__track");
    var slides = slider.querySelectorAll(".visit-slider__slide");
    var btnPrev = slider.querySelector(".visit-slider__arrow--prev");
    var btnNext = slider.querySelector(".visit-slider__arrow--next");

    if (!track || slides.length === 0) return;

    var current = 0;
    var total = slides.length;
    var autoTimer = null;

    function goTo(index) {
      if (index < 0) index = total - 1;
      if (index >= total) index = 0;
      current = index;
      track.style.transform = "translateX(-" + current * 100 + "%)";
    }

    if (btnPrev) {
      btnPrev.addEventListener("click", function () {
        goTo(current - 1);
        resetAuto();
      });
    }
    if (btnNext) {
      btnNext.addEventListener("click", function () {
        goTo(current + 1);
        resetAuto();
      });
    }

    function startAuto() {
      autoTimer = regInterval(function () {
        goTo(current + 1);
      }, 5000);
      slider._visitTimer = autoTimer;
    }
    function resetAuto() {
      clearInterval(autoTimer);
      startAuto();
    }

    var touchStartX = 0;
    track.addEventListener(
      "touchstart",
      function (e) {
        touchStartX = e.changedTouches[0].screenX;
      },
      { passive: true },
    );
    track.addEventListener(
      "touchend",
      function (e) {
        var diff = touchStartX - e.changedTouches[0].screenX;
        if (Math.abs(diff) > 50) {
          diff > 0 ? goTo(current + 1) : goTo(current - 1);
          resetAuto();
        }
      },
      { passive: true },
    );

    slider._visitCtrl = {
      goTo: goTo,
      next: function () {
        goTo(current + 1);
      },
      prev: function () {
        goTo(current - 1);
      },
      resetAuto: resetAuto,
    };

    goTo(0);
    startAuto();
  }

  /* Global keydown for visit sliders — bound ONCE */
  if (!REG.visitKeydownBound) {
    document.addEventListener("keydown", function (e) {
      document.querySelectorAll(".visit-slider").forEach(function (s) {
        if (!s._visitCtrl) return;
        if (e.key === "ArrowLeft") {
          s._visitCtrl.prev();
          s._visitCtrl.resetAuto();
        }
        if (e.key === "ArrowRight") {
          s._visitCtrl.next();
          s._visitCtrl.resetAuto();
        }
      });
    });
    REG.visitKeydownBound = true;
  }

  /* ============================================================
     4. MISSION SHUFFLE
     ============================================================ */
  function initMissionShuffle() {
    document.querySelectorAll(".mission-section").forEach(function (section) {
      var shuffleBtn = section.querySelector("[data-mission-shuffle]");
      var grid = section.querySelector("[data-mission-grid]");
      if (!shuffleBtn || !grid) return;

      /* Remove old matchMedia listener if re-initializing same section */
      if (section._missionMQ && section._missionMQListener) {
        if (typeof section._missionMQ.removeEventListener === "function") {
          section._missionMQ.removeEventListener(
            "change",
            section._missionMQListener,
          );
        } else if (typeof section._missionMQ.removeListener === "function") {
          section._missionMQ.removeListener(section._missionMQListener);
        }
      }

      var mobileQuery = window.matchMedia("(max-width: 566px)");
      var mobileVisibleCount = 3;
      var isAnimating = false;

      function shuffleArray(arr) {
        var shuffled = arr.slice();
        for (var i = shuffled.length - 1; i > 0; i--) {
          var j = Math.floor(Math.random() * (i + 1));
          var tmp = shuffled[i];
          shuffled[i] = shuffled[j];
          shuffled[j] = tmp;
        }
        var same = shuffled.every(function (card, idx) {
          return card === arr[idx];
        });
        if (same) shuffled.push(shuffled.shift());
        return shuffled;
      }

      function visibleCards(cards) {
        return mobileQuery.matches ? cards.slice(0, mobileVisibleCount) : cards;
      }

      function syncMobileCards() {
        var cards = Array.from(grid.querySelectorAll(".card"));
        cards.forEach(function (card, index) {
          card.classList.toggle(
            "is-mission-hidden",
            mobileQuery.matches && index >= mobileVisibleCount,
          );
        });
      }

      function clearCardStyles(cards) {
        cards.forEach(function (card) {
          card.style.transitionDelay = "";
          card.style.transform = "";
          card.style.opacity = "";
          card.style.pointerEvents = "";
        });
      }

      shuffleBtn.addEventListener("click", function () {
        if (isAnimating) return;
        var cards = Array.from(grid.querySelectorAll(".card"));
        var cardsToAnimateOut = visibleCards(cards);
        if (cards.length < 2) return;

        isAnimating = true;
        shuffleBtn.disabled = true;
        shuffleBtn.classList.add("is-shuffling");

        cardsToAnimateOut.forEach(function (card, i) {
          card.style.transitionDelay = i * 40 + "ms";
          card.style.transform = "translateX(-40px)";
          card.style.opacity = "0";
          card.style.pointerEvents = "none";
        });

        setTimeout(
          function () {
            var shuffled = shuffleArray(cards);
            shuffled.forEach(function (card) {
              grid.appendChild(card);
              card.style.transitionDelay = "0ms";
              card.style.transform = "translateX(40px)";
              card.style.opacity = "0";
            });
            syncMobileCards();
            void grid.offsetWidth;

            var cardsToAnimateIn = visibleCards(shuffled);
            cardsToAnimateIn.forEach(function (card, i) {
              card.style.transitionDelay = i * 50 + "ms";
              card.style.transform = "translateX(0)";
              card.style.opacity = "1";
            });

            setTimeout(
              function () {
                clearCardStyles(shuffled);
                shuffleBtn.disabled = false;
                shuffleBtn.classList.remove("is-shuffling");
                isAnimating = false;
              },
              350 + cardsToAnimateIn.length * 50,
            );
          },
          350 + cardsToAnimateOut.length * 40,
        );
      });

      syncMobileCards();

      var mqHandler = syncMobileCards;
      section._missionMQ = mobileQuery;
      section._missionMQListener = mqHandler;

      if (typeof mobileQuery.addEventListener === "function") {
        mobileQuery.addEventListener("change", mqHandler);
      } else if (typeof mobileQuery.addListener === "function") {
        mobileQuery.addListener(mqHandler);
      }
    });
  }

  /* ============================================================
     5. RESOURCE CENTER DROPDOWNS (standalone — idempotent)
     ============================================================ */
  function initResourceCenterDropdowns() {
    var HOVER_CLOSE_DELAY = 150;

    function closeAllDropdowns(except) {
      document.querySelectorAll("[data-rc-dropdown]").forEach(function (dd) {
        if (dd === except) return;
        var btn = dd.querySelector("button");
        var menu = dd.querySelector(".rc-dropdown__menu");
        dd.classList.remove("is-open");
        if (btn) btn.setAttribute("aria-expanded", "false");
        if (menu) menu.hidden = true;
        clearTimeout(dd._rcCloseTimer);
      });
    }

    function openDropdown(dd, btn, menu) {
      clearTimeout(dd._rcCloseTimer);
      closeAllDropdowns(dd);
      dd.classList.add("is-open");
      btn.setAttribute("aria-expanded", "true");
      menu.hidden = false;
    }

    function scheduleClose(dd, btn, menu) {
      clearTimeout(dd._rcCloseTimer);
      dd._rcCloseTimer = setTimeout(function () {
        dd.classList.remove("is-open");
        btn.setAttribute("aria-expanded", "false");
        menu.hidden = true;
      }, HOVER_CLOSE_DELAY);
    }

    var dropdowns = document.querySelectorAll("[data-rc-dropdown]");
    dropdowns.forEach(function (dd) {
      if (dd.dataset.rcDropdownBound === "1") return;
      var btn = dd.querySelector("button");
      var menu = dd.querySelector(".rc-dropdown__menu");
      if (!btn || !menu) return;

      dd.addEventListener("mouseenter", function () {
        openDropdown(dd, btn, menu);
      });
      dd.addEventListener("mouseleave", function () {
        scheduleClose(dd, btn, menu);
      });

      btn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (dd.classList.contains("is-open")) {
          scheduleClose(dd, btn, menu);
          clearTimeout(dd._rcCloseTimer);
          dd.classList.remove("is-open");
          btn.setAttribute("aria-expanded", "false");
          menu.hidden = true;
        } else {
          openDropdown(dd, btn, menu);
        }
      });

      dd.addEventListener("focusin", function () {
        openDropdown(dd, btn, menu);
      });
      dd.addEventListener("focusout", function (e) {
        if (!dd.contains(e.relatedTarget)) scheduleClose(dd, btn, menu);
      });
      menu.addEventListener("click", function (e) {
        e.stopPropagation();
      });

      dd.dataset.rcDropdownBound = "1";
    });

    if (!document.body.dataset.rcDropdownDocBound && dropdowns.length) {
      document.addEventListener("click", function () {
        closeAllDropdowns();
      });
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape") closeAllDropdowns();
      });
      document.body.dataset.rcDropdownDocBound = "1";
    }
  }

  /* ============================================================
     6. RESOURCE CENTER ROWS
     ============================================================ */
  function initResourceCenterRows() {
    var rows = document.querySelectorAll("[data-rc-row]");
    if (!rows.length) return;

    rows.forEach(function (row) {
      // Desktop hover
      row.addEventListener("mouseenter", function () {
        if (window.innerWidth > 991) {
          row.classList.add("is-open");
        }
      });

      row.addEventListener("mouseleave", function () {
        if (window.innerWidth > 991) {
          row.classList.remove("is-open");
        }
      });

      // Desktop click
      row.addEventListener("click", function (e) {
        if (window.innerWidth <= 991) {
          return; // Mobile uses the normal <a>
        }

        const url = row.dataset.link;
        const target = row.dataset.target || "_self";

        if (!url) return;

        if (target === "_blank") {
          window.open(url, "_blank");
        } else {
          window.location.href = url;
        }
      });
    });
  }

  /* ============================================================
     7. MOBILE MENU (persistent — idempotent)
     ============================================================ */
  function initMobileMenu() {
    var toggle = document.querySelector(".menu-toggle");
    var menu = document.querySelector("#mobile-menu");
    var backdrop = document.querySelector(".mobile-menu__backdrop");
    var closeBtn = document.querySelector(".mobile-menu__close");
    var body = document.body;

    if (!toggle || !menu || toggle.dataset.mobileMenuBound === "1") return;

    function openMenu() {
      menu.classList.add("is-open");
      menu.setAttribute("aria-hidden", "false");
      toggle.classList.add("is-active");
      toggle.setAttribute("aria-expanded", "true");
      toggle.setAttribute("aria-label", "Close menu");
      if (backdrop) backdrop.classList.add("is-visible");
      body.classList.add("menu-open");
      var firstLink = menu.querySelector(
        ".mobile-menu__nav a, .mobile-menu__close",
      );
      if (firstLink) {
        setTimeout(function () {
          firstLink.focus();
        }, 400);
      }
    }

    function closeMenu(restoreFocus) {
      menu.classList.remove("is-open");
      menu.setAttribute("aria-hidden", "true");
      toggle.classList.remove("is-active");
      toggle.setAttribute("aria-expanded", "false");
      toggle.setAttribute("aria-label", "Open menu");
      if (backdrop) backdrop.classList.remove("is-visible");
      body.classList.remove("menu-open");
      if (restoreFocus !== false) toggle.focus();
    }

    toggle.addEventListener("click", function (event) {
      event.preventDefault();
      menu.classList.contains("is-open") ? closeMenu(false) : openMenu();
    });

    if (closeBtn) {
      closeBtn.addEventListener("click", function () {
        closeMenu();
      });
    }
    if (backdrop) {
      backdrop.addEventListener("click", function () {
        closeMenu(false);
      });
    }

    if (!body.dataset.mobileMenuEscapeBound) {
      document.addEventListener("keydown", function (event) {
        if (event.key === "Escape" && menu.classList.contains("is-open"))
          closeMenu();
      });
      body.dataset.mobileMenuEscapeBound = "1";
    }

    menu.querySelectorAll("a").forEach(function (link) {
      link.addEventListener("click", function () {
        closeMenu(false);
      });
    });

    toggle.dataset.mobileMenuBound = "1";
  }

  /* ============================================================
     8. HEADER STICKY
     ============================================================ */
  var _headerScrollHandler = null;
  var _headerResizeHandler = null;

  function initHeaderSticky() {
    var header = document.querySelector(".site-header");
    if (!header) return;

    var body = document.body;
    var isHomepage = body.classList.contains("homepage-header");

    function updateHeaderHeight() {
      body.style.setProperty(
        "--header-height",
        isHomepage ? "0px" : header.offsetHeight + "px",
      );
    }

    updateHeaderHeight();

    if (_headerResizeHandler)
      window.removeEventListener("resize", _headerResizeHandler);
    _headerResizeHandler = updateHeaderHeight;
    window.addEventListener("resize", _headerResizeHandler, { passive: true });

    if (_headerScrollHandler)
      window.removeEventListener("scroll", _headerScrollHandler);
    _headerScrollHandler = function () {
      header.classList.toggle("is-scrolled", window.scrollY > 10);
    };
    window.addEventListener("scroll", _headerScrollHandler, { passive: true });
  }

  /* ============================================================
     9. FAQ SECTION
     ============================================================ */
  function initFAQ() {
    var sections = document.querySelectorAll(".faq-section");
    if (!sections.length) return;

    var ONE_AT_A_TIME = true;

    sections.forEach(function (section) {
      var items = section.querySelectorAll(".faq-item");
      if (!items.length) return;

      function openItem(item) {
        var btn = item.querySelector(".faq-item__trigger");
        var panel = item.querySelector(".faq-item__panel");
        item.classList.add("is-open");
        btn.setAttribute("aria-expanded", "true");
        panel.removeAttribute("hidden");
      }
      function closeItem(item) {
        var btn = item.querySelector(".faq-item__trigger");
        var panel = item.querySelector(".faq-item__panel");
        item.classList.remove("is-open");
        btn.setAttribute("aria-expanded", "false");
        panel.setAttribute("hidden", "");
      }
      function closeAll(except) {
        items.forEach(function (item) {
          if (item !== except) closeItem(item);
        });
      }

      items.forEach(function (item) {
        var btn = item.querySelector(".faq-item__trigger");
        if (!btn) return;

        btn.addEventListener("click", function () {
          var isOpen = item.classList.contains("is-open");
          if (ONE_AT_A_TIME && !isOpen) closeAll(item);
          isOpen ? closeItem(item) : openItem(item);
        });
        btn.addEventListener("keydown", function (e) {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            btn.click();
          }
        });
      });
    });
  }

  /* ============================================================
     PEOPLE ACCORDION
     ============================================================ */
  /* ============================================================
   PEOPLE ACCORDION
   ============================================================ */
  function initPeopleAccordion(scope) {
    var root = scope || document;
    var blocks = root.querySelectorAll("[data-people-accordion]");
    if (!blocks.length) return;

    blocks.forEach(function (block) {
      // idempotency guard (safe to call again after Barba transitions)
      if (block.dataset.accordionReady === "true") return;
      block.dataset.accordionReady = "true";

      var ONE_AT_A_TIME = block.dataset.allowMultiple !== "true";
      var items = block.querySelectorAll(".people-accordion__item");
      if (!items.length) return;

      function openItem(item) {
        var btn = item.querySelector(".people-accordion__trigger");
        if (!btn) return;
        item.classList.add("is-open");
        btn.setAttribute("aria-expanded", "true");
      }

      function closeItem(item) {
        var btn = item.querySelector(".people-accordion__trigger");
        if (!btn) return;
        item.classList.remove("is-open");
        btn.setAttribute("aria-expanded", "false");
      }

      function closeAll(except) {
        items.forEach(function (item) {
          if (item !== except) closeItem(item);
        });
      }

      items.forEach(function (item) {
        var btn = item.querySelector(".people-accordion__trigger");
        if (!btn) return; // static rows (no content) have no trigger

        btn.addEventListener("click", function () {
          var isOpen = item.classList.contains("is-open");
          if (ONE_AT_A_TIME && !isOpen) closeAll(item);
          isOpen ? closeItem(item) : openItem(item);
        });
      });

      // Optional: Arrow / Home / End navigation between rows
      block.addEventListener("keydown", function (e) {
        var current = e.target.closest(".people-accordion__trigger");
        if (!current) return;

        var triggers = Array.prototype.slice.call(
          block.querySelectorAll(".people-accordion__trigger"),
        );
        var index = triggers.indexOf(current);
        var next = null;

        if (e.key === "ArrowDown")
          next = triggers[(index + 1) % triggers.length];
        if (e.key === "ArrowUp")
          next = triggers[(index - 1 + triggers.length) % triggers.length];
        if (e.key === "Home") next = triggers[0];
        if (e.key === "End") next = triggers[triggers.length - 1];

        if (next) {
          e.preventDefault();
          next.focus();
        }
      });
    });
  }
  /* ============================================================
     10. SUPPORT PAGE SLIDER (Events Slider)
     ============================================================ */
  function initSliders() {
    var sliders = document.querySelectorAll(".events-slider__slider");

    sliders.forEach(function (slider) {
      if (slider._eventsTimer) clearInterval(slider._eventsTimer);
      if (slider._eventsResizeHandler)
        window.removeEventListener("resize", slider._eventsResizeHandler);

      var track = slider.querySelector(".slider-track");
      var slides = slider.querySelectorAll(".slider-slide");
      var prevBtn = slider.querySelector(".slider-btn--prev");
      var nextBtn = slider.querySelector(".slider-btn--next");

      if (!track || slides.length <= 1) return;

      track.style.transition = "transform 0.4s ease";
      track.style.willChange = "transform";

      var currentIndex = 0;
      var totalSlides = slides.length;

      function updateSlider() {
        track.style.transform =
          "translateX(" + -currentIndex * slider.offsetWidth + "px)";
      }
      function goToNext() {
        currentIndex = (currentIndex + 1) % totalSlides;
        updateSlider();
      }
      function goToPrev() {
        currentIndex = (currentIndex - 1 + totalSlides) % totalSlides;
        updateSlider();
      }
      function startAutoPlay() {
        slider._eventsTimer = regInterval(goToNext, 5000);
      }
      function stopAutoPlay() {
        clearInterval(slider._eventsTimer);
      }

      if (nextBtn) {
        nextBtn.addEventListener("click", function () {
          stopAutoPlay();
          goToNext();
          startAutoPlay();
        });
      }
      if (prevBtn) {
        prevBtn.addEventListener("click", function () {
          stopAutoPlay();
          goToPrev();
          startAutoPlay();
        });
      }

      slider.setAttribute("tabindex", "0");
      slider.addEventListener("keydown", function (e) {
        if (e.key === "ArrowRight") {
          stopAutoPlay();
          goToNext();
          startAutoPlay();
        } else if (e.key === "ArrowLeft") {
          stopAutoPlay();
          goToPrev();
          startAutoPlay();
        }
      });

      var touchStartX = 0;
      track.addEventListener(
        "touchstart",
        function (e) {
          touchStartX = e.changedTouches[0].screenX;
          stopAutoPlay();
        },
        { passive: true },
      );
      track.addEventListener(
        "touchend",
        function (e) {
          var diff = touchStartX - e.changedTouches[0].screenX;
          if (Math.abs(diff) > 50) {
            diff > 0 ? goToNext() : goToPrev();
          }
          startAutoPlay();
        },
        { passive: true },
      );

      var resizeTimer;
      var onResize = function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          track.style.transition = "none";
          updateSlider();
          setTimeout(function () {
            track.style.transition = "transform 0.4s ease";
          }, 50);
        }, 250);
      };
      window.addEventListener("resize", onResize);
      slider._eventsResizeHandler = onResize;

      updateSlider();
      startAutoPlay();
    });
  }

  /* ============================================================
     11. RESOURCE CENTER AJAX
     ============================================================ */
  function initResourceCenterAjax() {
    var block = document.querySelector("[data-rc-block]");
    if (!block) return;
    if (block._rcAjaxInit) return;
    block._rcAjaxInit = true;

    var resultsEl = block.querySelector("[data-rc-results]");
    var activeFiltersEl = block.querySelector("[data-rc-active-filters]");
    var searchInputs = block.querySelectorAll("[data-rc-search]");
    var mobileSearch = block.querySelector("[data-rc-mobile-search]");
    var mobileSearchOpen = block.querySelector("[data-rc-mobile-search-open]");
    var mobileSearchClose = block.querySelector(
      "[data-rc-mobile-search-close]",
    );
    var mobileFilter = block.querySelector("[data-rc-mobile-filter]");
    var mobileFilterToggle = block.querySelector(
      "[data-rc-mobile-filter-toggle]",
    );
    var mobileFilterCloseControls = block.querySelectorAll(
      "[data-rc-mobile-filter-close]",
    );
    var mobileFilterPanel = mobileFilter
      ? mobileFilter.querySelector(".rc-mobile-filter__panel")
      : null;
    var ajaxUrl = block.dataset.rcAjax;
    var nonce = block.dataset.rcNonce;

    var initialTypeParam =
      new URLSearchParams(location.search).get("rc_type") || "";
    var state = {
      rc_sort: new URLSearchParams(location.search).get("rc_sort") || "newest",
      rc_type: initialTypeParam
        ? initialTypeParam.split(",").filter(Boolean)
        : [],
      rc_search: new URLSearchParams(location.search).get("rc_search") || "",
      rc_page: parseInt(
        new URLSearchParams(location.search).get("rc_page") || "1",
        10,
      ),
    };

    async function fetchResults(pushHistory) {
      if (pushHistory === undefined) pushHistory = true;
      resultsEl.setAttribute("aria-busy", "true");
      resultsEl.classList.add("is-loading");

      var body = new FormData();
      body.append("action", "rc_fetch");
      body.append("nonce", nonce);
      body.append("rc_sort", state.rc_sort);
      body.append("rc_type", state.rc_type.join(","));
      body.append("rc_search", state.rc_search);
      body.append("rc_page", state.rc_page);

      try {
        var res = await fetch(ajaxUrl, { method: "POST", body: body });
        var data = await res.json();
        if (data.success) {
          resultsEl.innerHTML = data.data.html;
          bindPaginationButtons();
          updateActiveFilters();
          if (pushHistory) {
            history.pushState(Object.assign({}, state), "", buildURL());
          }
          resultsEl.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      } catch (err) {
        console.error("Resource Center fetch error:", err);
      } finally {
        resultsEl.removeAttribute("aria-busy");
        resultsEl.classList.remove("is-loading");
      }
    }

    function buildURL() {
      var params = new URLSearchParams();
      if (state.rc_sort && state.rc_sort !== "newest")
        params.set("rc_sort", state.rc_sort);
      if (state.rc_type.length) params.set("rc_type", state.rc_type.join(","));
      if (state.rc_search) params.set("rc_search", state.rc_search);
      if (state.rc_page > 1) params.set("rc_page", state.rc_page);
      var qs = params.toString();
      return location.pathname + (qs ? "?" + qs : "");
    }

    function updateActiveFilters() {
      var tags = [];
      state.rc_type.forEach(function (slug) {
        var btn = block.querySelector('[data-rc-filter="' + slug + '"]');
        tags.push({
          label: btn ? btn.textContent.trim() : slug,
          key: "rc_type",
          value: slug,
        });
      });
      if (state.rc_search)
        tags.push({
          label: state.rc_search,
          key: "rc_search",
          value: state.rc_search,
        });

      if (!tags.length) {
        activeFiltersEl.innerHTML = "";
        return;
      }

      activeFiltersEl.innerHTML = tags
        .map(function (tag) {
          return (
            '<span class="rc-filter-tag">' +
            escHtml(tag.label) +
            '<button type="button" class="rc-filter-tag__remove" data-rc-remove="' +
            tag.key +
            '" data-rc-remove-value="' +
            escHtml(tag.value) +
            '" aria-label="Remove ' +
            escHtml(tag.label) +
            '">' +
            '<svg width="12" height="12" viewBox="0 0 24 24" fill="none"><path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>' +
            "</button></span>"
          );
        })
        .join("");

      activeFiltersEl
        .querySelectorAll("[data-rc-remove]")
        .forEach(function (btn) {
          btn.addEventListener("click", function () {
            var key = this.dataset.rcRemove;
            var value = this.dataset.rcRemoveValue;
            if (key === "rc_type") {
              state.rc_type = state.rc_type.filter(function (v) {
                return v !== value;
              });
            } else {
              state[key] = "";
            }
            state.rc_page = 1;
            updateDropdownActiveStates();
            updateActiveFilters();
            fetchResults();
          });
        });
    }

    function updateDropdownActiveStates() {
      block.querySelectorAll("[data-rc-sort]").forEach(function (btn) {
        btn.classList.toggle("is-active", btn.dataset.rcSort === state.rc_sort);
        btn.setAttribute(
          "aria-current",
          btn.dataset.rcSort === state.rc_sort ? "true" : "false",
        );
      });
      block.querySelectorAll("[data-rc-filter]").forEach(function (btn) {
        var isActive = state.rc_type.indexOf(btn.dataset.rcFilter) !== -1;
        btn.classList.toggle("is-active", isActive);
        btn.setAttribute("aria-pressed", isActive ? "true" : "false");
      });
      searchInputs.forEach(function (input) {
        input.value = state.rc_search;
      });
    }

    block.querySelectorAll("[data-rc-sort]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        state.rc_sort = this.dataset.rcSort;
        state.rc_page = 1;
        updateDropdownActiveStates();
        closeAllDropdowns();
        closeMobileFilter();
        fetchResults();
      });
    });

    block.querySelectorAll("[data-rc-filter]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var slug = this.dataset.rcFilter;
        var idx = state.rc_type.indexOf(slug);
        if (idx === -1) state.rc_type.push(slug);
        else state.rc_type.splice(idx, 1);
        state.rc_page = 1;
        updateDropdownActiveStates();
        fetchResults();
      });
    });

    var searchTimer;
    searchInputs.forEach(function (input) {
      input.addEventListener("input", function () {
        clearTimeout(searchTimer);
        searchTimer = setTimeout(function () {
          state.rc_search = input.value.trim();
          state.rc_page = 1;
          updateDropdownActiveStates();
          fetchResults();
        }, 400);
      });
    });

    function bindPaginationButtons() {
      resultsEl.querySelectorAll("[data-rc-page]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          state.rc_page = parseInt(this.dataset.rcPage, 10);
          fetchResults();
        });
      });
    }
    bindPaginationButtons();

    block.querySelectorAll("[data-rc-dropdown]").forEach(function (dropdown) {
      var toggle = dropdown.querySelector("button[aria-expanded]");
      var menu = dropdown.querySelector(".rc-dropdown__menu");
      if (!toggle || !menu) return;
      toggle.addEventListener("click", function () {
        var isOpen = this.getAttribute("aria-expanded") === "true";
        closeAllDropdowns();
        if (!isOpen) {
          this.setAttribute("aria-expanded", "true");
          menu.hidden = false;
        }
      });
      menu.addEventListener("click", function (e) {
        e.stopPropagation();
      });
    });

    function closeAllDropdowns() {
      block.querySelectorAll("[data-rc-dropdown]").forEach(function (d) {
        var t = d.querySelector("button[aria-expanded]");
        var m = d.querySelector(".rc-dropdown__menu");
        if (t) t.setAttribute("aria-expanded", "false");
        if (m) m.hidden = true;
      });
    }

    function openMobileSearch() {
      if (!mobileSearch) return;
      closeMobileFilter(false);
      closeAllDropdowns();
      mobileSearch.hidden = false;
      block.classList.add("is-rc-searching");
      var input = mobileSearch.querySelector("[data-rc-search]");
      if (input)
        setTimeout(function () {
          input.focus();
        }, 0);
    }
    function closeMobileSearch(restoreFocus) {
      if (restoreFocus === undefined) restoreFocus = true;
      if (!mobileSearch) return;
      mobileSearch.hidden = true;
      block.classList.remove("is-rc-searching");
      if (restoreFocus && mobileSearchOpen) mobileSearchOpen.focus();
    }
    function openMobileFilter() {
      if (!mobileFilter) return;
      closeMobileSearch(false);
      closeAllDropdowns();
      mobileFilter.hidden = false;
      mobileFilter.setAttribute("aria-hidden", "false");
      if (mobileFilterToggle)
        mobileFilterToggle.setAttribute("aria-expanded", "true");
      document.body.classList.add("rc-mobile-filter-open");
      if (mobileFilterPanel)
        setTimeout(function () {
          mobileFilterPanel.focus();
        }, 0);
    }
    function closeMobileFilter(restoreFocus) {
      if (restoreFocus === undefined) restoreFocus = true;
      if (!mobileFilter || mobileFilter.hidden) return;
      mobileFilter.hidden = true;
      mobileFilter.setAttribute("aria-hidden", "true");
      if (mobileFilterToggle)
        mobileFilterToggle.setAttribute("aria-expanded", "false");
      document.body.classList.remove("rc-mobile-filter-open");
      if (restoreFocus && mobileFilterToggle) mobileFilterToggle.focus();
    }

    if (mobileSearchOpen)
      mobileSearchOpen.addEventListener("click", openMobileSearch);
    if (mobileSearchClose)
      mobileSearchClose.addEventListener("click", function () {
        closeMobileSearch();
      });
    if (mobileFilterToggle) {
      mobileFilterToggle.addEventListener("click", function () {
        mobileFilter && !mobileFilter.hidden
          ? closeMobileFilter()
          : openMobileFilter();
      });
    }
    mobileFilterCloseControls.forEach(function (control) {
      control.addEventListener("click", function () {
        closeMobileFilter();
      });
    });

    /* Store controller on block so global handlers can reach it */
    block._rcCtrl = {
      closeAllDropdowns: closeAllDropdowns,
      closeMobileFilter: closeMobileFilter,
      closeMobileSearch: closeMobileSearch,
      updateDropdownActiveStates: updateDropdownActiveStates,
      updateActiveFilters: updateActiveFilters,
      fetchResults: fetchResults,
      state: state,
    };

    function escHtml(str) {
      return String(str)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;");
    }

    updateDropdownActiveStates();
    updateActiveFilters();
  }

  /* Global RC AJAX handlers — bound ONCE, query current block dynamically */
  if (!document._rcAjaxGlobalBound) {
    document.addEventListener("click", function (e) {
      var block = document.querySelector("[data-rc-block]");
      if (!block || !block._rcCtrl) return;
      if (!e.target.closest("[data-rc-dropdown]"))
        block._rcCtrl.closeAllDropdowns();
    });
    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape") return;
      var block = document.querySelector("[data-rc-block]");
      if (!block || !block._rcCtrl) return;
      var mf = block.querySelector("[data-rc-mobile-filter]");
      var ms = block.querySelector("[data-rc-mobile-search]");
      if (mf && !mf.hidden) {
        block._rcCtrl.closeMobileFilter();
        return;
      }
      if (ms && !ms.hidden) {
        block._rcCtrl.closeMobileSearch();
        return;
      }
      block._rcCtrl.closeAllDropdowns();
    });
    window.addEventListener("popstate", function () {
      var block = document.querySelector("[data-rc-block]");
      if (!block || !block._rcCtrl) return;
      var p = new URLSearchParams(location.search);
      var s = block._rcCtrl.state;
      s.rc_sort = p.get("rc_sort") || "newest";
      var typeParam = p.get("rc_type") || "";
      s.rc_type = typeParam ? typeParam.split(",").filter(Boolean) : [];
      s.rc_search = p.get("rc_search") || "";
      s.rc_page = parseInt(p.get("rc_page") || "1", 10);
      block._rcCtrl.updateDropdownActiveStates();
      block._rcCtrl.updateActiveFilters();
      block._rcCtrl.fetchResults(false);
    });
    document._rcAjaxGlobalBound = true;
  }

  /* ============================================================
   video modal
   ============================================================ */
  function initVideoModal() {
    const modal = document.querySelector(".video-modal");
    const iframe = document.querySelector("#youtube-player");
    const closeBtn = document.querySelector(".video-modal__close");
    const overlay = document.querySelector(".video-modal__overlay");

    if (!modal || !iframe) return;

    document.querySelectorAll(".video-trigger").forEach(function (btn) {
      if (btn.dataset.videoModalBound === "1") return;

      btn.addEventListener("click", function () {
        // Set the src with mute=1 (required for autoplay)
        iframe.src = btn.dataset.video;
        modal.classList.add("is-open");
        document.documentElement.classList.add("video-modal-locked");
        document.body.classList.add("video-modal-locked");

        // Try to unmute after a short delay using postMessage
        // This works because the CLICK is a user gesture
        setTimeout(function () {
          iframe.contentWindow.postMessage(
            JSON.stringify({
              event: "command",
              func: "unMute",
              args: [],
            }),
            "*",
          );
        }, 1000);
      });

      btn.dataset.videoModalBound = "1";
    });

    function closeVideo() {
      iframe.src = "";
      modal.classList.remove("is-open");
      document.documentElement.classList.remove("video-modal-locked");
      document.body.classList.remove("video-modal-locked");
    }

    if (closeBtn && !closeBtn.dataset.videoModalBound) {
      closeBtn.addEventListener("click", closeVideo);
      closeBtn.dataset.videoModalBound = "1";
    }

    if (overlay && !overlay.dataset.videoModalBound) {
      overlay.addEventListener("click", closeVideo);
      overlay.dataset.videoModalBound = "1";
    }

    if (!modal.dataset.escapeBound) {
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && modal.classList.contains("is-open")) {
          closeVideo();
        }
      });
      modal.dataset.escapeBound = "1";
    }
  }

  /* ============================================================
   VIDEO PREVIEW AUTOPLAY
  ============================================================ */
  function initPreviewVideos() {
    const videos = document.querySelectorAll(".video-trigger__gif");

    if (!videos.length) return;

    videos.forEach(function (video) {
      if (video.tagName !== "VIDEO") return;

      // Hard-reset playback state
      video.pause();
      video.currentTime = 0;
      video.muted = true;
      video.defaultMuted = true;
      video.loop = true;
      video.playsInline = true;
      video.preload = "auto";

      // Attempt to play
      var playPromise = video.play();

      if (playPromise !== undefined) {
        playPromise.catch(function (err) {
          console.warn("Preview autoplay blocked:", err);

          // Fallback: wait until enough data is buffered
          video.addEventListener(
            "canplaythrough",
            function () {
              video.play().catch(function (e) {
                console.warn("Preview play failed again:", e);
              });
            },
            { once: true },
          );

          // Force load if stalled
          video.load();
        });
      }
    });
  }
  /* ============================================================
     MASTER LIFECYCLE
     ============================================================ */
  function emanuelnineDestroyPage() {
    clearRegTimers();
    if (typeof gsap !== "undefined") {
      gsap.killTweensOf(".hero-carousel-slide");
      gsap.killTweensOf(".visit-slider__track");
      gsap.killTweensOf(".slider-track");
      gsap.killTweensOf(".page-transition");
    }
  }

  function initSplitMediaSliders(scope) {
    scope = scope || document;

    var AUTOPLAY_DELAY = 5000; // ms between slides
    var SLIDE_DURATION = 900; // ms, slide animation speed
    var PAUSE_ON_HOVER = true; // pause while a mouse is over the slider
    var RESPECT_REDUCED_MOTION = true; // set false to always autoplay
    var PREV_REVERSES = true; // false = prev button also slides right to left

    var reduceMotion =
      RESPECT_REDUCED_MOTION &&
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    var sliders = [];
    if (scope.matches && scope.matches("[data-split-slider]")) {
      sliders.push(scope);
    }
    sliders = sliders.concat(
      Array.prototype.slice.call(scope.querySelectorAll("[data-split-slider]")),
    );

    sliders.forEach(function (slider) {
      if (slider.dataset.splitInit === "true") return;

      var slides = slider.querySelectorAll("[data-split-slide]");
      if (!slides.length) return;

      slider.dataset.splitInit = "true";
      slider.style.setProperty("--split-duration", SLIDE_DURATION + "ms");

      var dots = slider.querySelectorAll("[data-split-dot]");
      var prev = slider.querySelector("[data-split-prev]");
      var next = slider.querySelector("[data-split-next]");
      var current = 0;
      var timer = null;
      var observer = null;
      var isInView = true;
      var isPaused = false;
      var isAnimating = false;

      // place a slide at x% (animate = true uses the CSS transition)
      function place(slide, percent, animate) {
        slide.style.transition = animate ? "" : "none";
        slide.style.transform = "translate3d(" + percent + "%,0,0)";
      }

      // initial: first slide visible, all others waiting on the right
      slides.forEach(function (slide, i) {
        place(slide, i === 0 ? 0 : 100, false);
        slide.setAttribute("aria-hidden", i === 0 ? "false" : "true");
      });

      // ---------- Slide ----------
      // direction: 1 = enters from the right (default), -1 = enters from the left
      function goTo(index, direction) {
        index = (index + slides.length) % slides.length;
        if (index === current || isAnimating) return;
        direction = direction || 1;

        var outgoing = slides[current];
        var incoming = slides[index];
        isAnimating = true;

        // 1. park the incoming slide on its entry side (no animation)
        incoming.classList.add("is-active");
        incoming.setAttribute("aria-hidden", "false");
        place(incoming, direction * 100, false);
        void incoming.offsetWidth; // force reflow

        // 2. next frames: animate incoming to 0 and outgoing out the far side
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            place(incoming, 0, true);
            place(outgoing, -direction * 100, true);
          });
        });

        current = index;
        dots.forEach(function (dot, i) {
          dot.classList.toggle("is-active", i === current);
        });

        // 3. after the animation: snap the outgoing slide back to the right
        setTimeout(function () {
          place(outgoing, 100, false);
          outgoing.classList.remove("is-active");
          outgoing.setAttribute("aria-hidden", "true");
          isAnimating = false;
        }, SLIDE_DURATION + 60);
      }

      // ---------- Autoplay ----------
      function stopAutoplay() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      function destroy() {
        stopAutoplay();
        if (observer) observer.disconnect();
        document.removeEventListener("visibilitychange", updateAutoplay);
      }

      function updateAutoplay() {
        // slider was removed from the DOM (Barba transition)
        if (!slider.isConnected) {
          destroy();
          return;
        }

        var shouldPlay =
          !reduceMotion &&
          slides.length > 1 &&
          isInView &&
          !isPaused &&
          !document.hidden;

        if (!shouldPlay) {
          stopAutoplay();
          return;
        }

        if (!timer) {
          timer = setInterval(function () {
            if (!slider.isConnected) {
              destroy();
              return;
            }
            goTo(current + 1, 1);
          }, AUTOPLAY_DELAY);
        }
      }

      function restartAutoplay() {
        stopAutoplay();
        updateAutoplay();
      }

      // ---------- Controls ----------
      if (prev)
        prev.addEventListener("click", function () {
          goTo(current - 1, PREV_REVERSES ? -1 : 1);
          restartAutoplay();
        });
      if (next)
        next.addEventListener("click", function () {
          goTo(current + 1, 1);
          restartAutoplay();
        });
      dots.forEach(function (dot) {
        dot.addEventListener("click", function () {
          var index = Number(dot.dataset.splitDot);
          if (Number.isInteger(index) && index >= 0 && index < slides.length) {
            goTo(index, 1); // dots always slide right to left
            restartAutoplay();
          }
        });
      });

      // ---------- Pause rules ----------
      var canHover =
        window.matchMedia &&
        window.matchMedia("(hover: hover) and (pointer: fine)");

      if (PAUSE_ON_HOVER) {
        slider.addEventListener("mouseenter", function () {
          if (!canHover || !canHover.matches) return;
          isPaused = true;
          updateAutoplay();
        });
        slider.addEventListener("mouseleave", function () {
          isPaused = false;
          updateAutoplay();
        });
      }

      // pause only for keyboard focus, not after a mouse click
      slider.addEventListener("focusin", function (event) {
        var keyboardFocus = false;
        try {
          keyboardFocus = event.target.matches(":focus-visible");
        } catch (e) {}
        if (keyboardFocus) {
          isPaused = true;
          updateAutoplay();
        }
      });
      slider.addEventListener("focusout", function () {
        isPaused = false;
        updateAutoplay();
      });

      // swipe
      var startX = 0;
      slider.addEventListener(
        "touchstart",
        function (event) {
          if (event.changedTouches.length)
            startX = event.changedTouches[0].clientX;
          isPaused = true;
          updateAutoplay();
        },
        { passive: true },
      );
      slider.addEventListener(
        "touchend",
        function (event) {
          if (event.changedTouches.length) {
            var diff = event.changedTouches[0].clientX - startX;
            if (Math.abs(diff) > 50) {
              if (diff < 0) goTo(current + 1, 1);
              else goTo(current - 1, PREV_REVERSES ? -1 : 1);
            }
          }
          isPaused = false;
          restartAutoplay();
        },
        { passive: true },
      );

      // ---------- Visibility ----------
      document.addEventListener("visibilitychange", updateAutoplay);

      if ("IntersectionObserver" in window) {
        observer = new IntersectionObserver(
          function (entries) {
            isInView = entries[0].isIntersecting;
            updateAutoplay();
          },
          { threshold: 0.3 },
        );
        observer.observe(slider);
      }

      updateAutoplay();
    });
  }

  function emanuelnineInitPage() {
    initHeaderNavigation();
    initHeroCarousel();
    initVisitSlider();
    initMissionShuffle();
    initResourceCenterDropdowns();
    initResourceCenterRows();
    initMobileMenu();
    initHeaderSticky();
    initFAQ();
    initPeopleAccordion();
    initSliders();
    initResourceCenterAjax();
    initVideoModal();
    initPreviewVideos();
    initSplitMediaSliders();
  }

  /* Expose for Barba */
  window.emanuelnineInitPage = emanuelnineInitPage;
  window.emanuelnineDestroyPage = emanuelnineDestroyPage;
  window.initSplitMediaSliders = initSplitMediaSliders;
  window.initResourceCenterDropdowns = initResourceCenterDropdowns;
  window.emanuelnineInitSliders = initSliders;
  window.emanuelnineInitFAQ = initFAQ;
  window.emanuelnineInitResourceDropdowns = initResourceCenterDropdowns;
  window.emanuelnineInitResourceRows = initResourceCenterRows;

  /* Boot */
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", emanuelnineInitPage);
  } else {
    emanuelnineInitPage();
  }
})();
